import { useTheme } from "@mui/material";

function AthleteProfileWithCyclistSvg() {
  const { palette } = useTheme();
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.5828 2.47495C54.0524 -0.062287 63.7858 5.5571 66.3232 15.0262C68.8605 24.4952 63.2409 34.2282 53.7714 36.7655C42.3307 39.8308 35.0368 50.647 36.0258 62.0503C32.0459 54.5874 23.3216 50.5691 14.8013 52.852C7.13334 54.9065 1.87422 61.4635 1.10643 68.9163C-3.4146 39.3063 14.9756 10.4078 44.5828 2.47495Z"
        fill="url(#paint0_linear_9007_13335)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.1452 14.8059C65.0898 7.13533 58.5283 1.87539 51.0717 1.11079C80.6811 -3.42503 109.586 14.9591 117.518 44.5624C120.055 54.0275 114.437 63.7564 104.972 66.2925C95.5062 68.8287 85.7768 63.2117 83.2406 53.7466C80.1784 42.3189 69.3788 35.0305 57.9881 36.0071C65.4247 32.0171 69.424 23.31 67.1452 14.8059Z"
        fill="url(#paint1_linear_9007_13335)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.4356 117.519C105.053 109.583 123.441 80.6586 118.883 51.0371C118.123 58.495 112.864 65.0591 105.192 67.1146L105.173 67.1196L105.154 67.1229C95.4421 68.797 89.7008 65.4178 86.4194 61.6343C85.3781 60.4337 84.5888 59.1977 83.9987 58.0796C84.9304 69.4374 77.6498 80.1889 66.2509 83.243C56.7854 85.7792 51.1682 95.5081 53.7045 104.973C56.2407 114.438 65.9701 120.055 75.4356 117.519Z"
        fill="url(#paint2_linear_9007_13335)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.7538 66.2535C39.8207 77.6986 50.6486 84.9918 62.0584 83.9885C54.6104 87.9713 50.6022 96.684 52.8824 105.193C54.9378 112.864 61.5013 118.123 68.9588 118.884C39.3367 123.44 10.412 105.053 2.47618 75.4377C-0.0600865 65.9727 5.55715 56.2438 15.0227 53.7076C24.4882 51.1714 34.2176 56.7884 36.7538 66.2535Z"
        fill="url(#paint3_linear_9007_13335)"
      />
      <path
        d="M66.75 70.5C65.86 70.5 64.99 70.2361 64.2499 69.7416C63.5099 69.2471 62.9331 68.5443 62.5925 67.7221C62.2519 66.8998 62.1628 65.995 62.3365 65.1221C62.5101 64.2492 62.9387 63.4474 63.568 62.818C64.1974 62.1887 64.9992 61.7601 65.8721 61.5865C66.745 61.4128 67.6498 61.5019 68.4721 61.8425C69.2943 62.1831 69.9971 62.7599 70.4916 63.4999C70.9861 64.24 71.25 65.11 71.25 66C71.2486 67.1931 70.7741 68.3369 69.9305 69.1805C69.0869 70.0241 67.9431 70.4986 66.75 70.5ZM66.75 63C66.1567 63 65.5766 63.1759 65.0833 63.5056C64.5899 63.8352 64.2054 64.3038 63.9784 64.852C63.7513 65.4001 63.6919 66.0033 63.8076 66.5853C63.9234 67.1672 64.2091 67.7018 64.6287 68.1213C65.0482 68.5409 65.5828 68.8266 66.1647 68.9424C66.7467 69.0581 67.3499 68.9987 67.8981 68.7716C68.4462 68.5446 68.9148 68.1601 69.2444 67.6667C69.5741 67.1734 69.75 66.5933 69.75 66C69.7491 65.2046 69.4328 64.4421 68.8703 63.8797C68.3079 63.3173 67.5454 63.0009 66.75 63Z"
        fill={palette.text.primary}
      />
      <path
        d="M53.25 70.5C52.36 70.5 51.49 70.2361 50.7499 69.7416C50.0099 69.2471 49.4331 68.5443 49.0925 67.7221C48.7519 66.8998 48.6628 65.995 48.8365 65.1221C49.0101 64.2492 49.4387 63.4474 50.068 62.818C50.6974 62.1887 51.4992 61.7601 52.3721 61.5865C53.245 61.4128 54.1498 61.5019 54.9721 61.8425C55.7943 62.1831 56.4971 62.7599 56.9916 63.4999C57.4861 64.24 57.75 65.11 57.75 66C57.7486 67.1931 57.2741 68.3369 56.4305 69.1805C55.5869 70.0241 54.4431 70.4986 53.25 70.5ZM53.25 63C52.6567 63 52.0766 63.1759 51.5833 63.5056C51.0899 63.8352 50.7054 64.3038 50.4784 64.852C50.2513 65.4001 50.1919 66.0033 50.3076 66.5853C50.4234 67.1672 50.7091 67.7018 51.1287 68.1213C51.5482 68.5409 52.0828 68.8266 52.6647 68.9424C53.2467 69.0581 53.8499 68.9987 54.3981 68.7716C54.9462 68.5446 55.4148 68.1601 55.7444 67.6667C56.0741 67.1734 56.25 66.5933 56.25 66C56.2491 65.2046 55.9328 64.4421 55.3703 63.8797C54.8079 63.3173 54.0454 63.0009 53.25 63Z"
        fill={palette.text.primary}
      />
      <path
        d="M60.75 68.25H59.25V63.3104L55.1887 59.25C54.9077 58.9684 54.75 58.5868 54.75 58.1891C54.75 57.7913 54.9077 57.4097 55.1887 57.1281L58.6281 53.6887C58.9096 53.4078 59.2911 53.25 59.6888 53.25C60.0865 53.25 60.468 53.4078 60.7496 53.6887L64.0605 57H68.25V58.4995L63.439 58.5L59.689 54.75L56.25 58.1887L60.75 62.6887V68.25Z"
        fill={palette.text.primary}
      />
      <path
        d="M64.125 54C63.6058 54 63.0983 53.846 62.6666 53.5576C62.235 53.2692 61.8985 52.8592 61.6998 52.3795C61.5011 51.8999 61.4492 51.3721 61.5504 50.8629C61.6517 50.3537 61.9017 49.886 62.2688 49.5188C62.636 49.1517 63.1037 48.9017 63.6129 48.8004C64.1221 48.6992 64.6499 48.7511 65.1295 48.9498C65.6092 49.1485 66.0192 49.485 66.3076 49.9166C66.596 50.3483 66.75 50.8558 66.75 51.375C66.7492 52.0709 66.4723 52.7381 65.9802 53.2302C65.4881 53.7223 64.8209 53.9992 64.125 54ZM64.125 50.25C63.9025 50.25 63.685 50.316 63.5 50.4396C63.315 50.5632 63.1708 50.7389 63.0856 50.9445C63.0005 51.15 62.9782 51.3762 63.0216 51.5945C63.065 51.8127 63.1722 52.0132 63.3295 52.1705C63.4868 52.3278 63.6873 52.435 63.9055 52.4784C64.1238 52.5218 64.35 52.4995 64.5555 52.4144C64.7611 52.3292 64.9368 52.185 65.0604 52C65.184 51.815 65.25 51.5975 65.25 51.375C65.2497 51.0767 65.131 50.7908 64.9201 50.5799C64.7092 50.369 64.4233 50.2503 64.125 50.25Z"
        fill={palette.text.primary}
      />
      <defs>
        <linearGradient
          id="paint0_linear_9007_13335"
          x1="67.4683"
          y1="10.6927"
          x2="19.4666"
          y2="60.7077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF36A4" />
          <stop offset="1" stopColor="#FFC2E4" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_9007_13335"
          x1="105.106"
          y1="66.8086"
          x2="96.8876"
          y2="-3.07665"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF8400" />
          <stop offset="1" stopColor="#FFCEA1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_9007_13335"
          x1="115.283"
          y1="49.7583"
          x2="56.3742"
          y2="105.045"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FEF39B" />
          <stop offset="1" stopColor="#FECF12" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_9007_13335"
          x1="15.3191"
          y1="53.1915"
          x2="58.9328"
          y2="114.86"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29D4FF" />
          <stop offset="1" stopColor="#A7EDFF" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default AthleteProfileWithCyclistSvg;
